import { render, staticRenderFns } from "./MemberReferences.vue?vue&type=template&id=190a531a"
import script from "./MemberReferences.vue?vue&type=script&lang=js"
export * from "./MemberReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports